import { getCurrWorkspaceAlias } from '@/utils/workspace';

import {
  type AppleAppInfoT,
  type AppleAppStoreInfo,
  IMPORT_STATE,
} from '../../features/Setting/Integrations/providers/types';
import { defaultAxios } from '..';

type AppleAppStoreInfoDTO = {
  alias: string;
  app_info: AppleAppInfoT;
  workspace_id: string;
};

const appleAppService = {
  async createAppleAppStoreInfo(
    app: AppleAppInfoT,
  ): Promise<AppleAppStoreInfo> {
    const wa = getCurrWorkspaceAlias();
    const res = await defaultAxios.post<AppleAppStoreInfoDTO>(
      `/workspaces/${wa}/apple_app_store/`,
      app,
    );
    return {
      alias: res.data.alias,
      app_info: res.data.app_info,
      workspace_id: res.data.workspace_id,
      import_state: IMPORT_STATE.FINISHED,
    };
  },
  async getAppleAppStoreInfos(wa: string): Promise<AppleAppStoreInfo[]> {
    const res = await defaultAxios.get<AppleAppStoreInfoDTO[]>(
      `/workspaces/${wa}/apple_app_store/`,
    );
    if (!res.data) return [];
    return res.data.map((d) => ({
      alias: d.alias,
      app_info: d.app_info,
      workspace_id: d.workspace_id,
      import_state: IMPORT_STATE.FINISHED,
    }));
  },
  async searchApp(
    term: string,
    country: string,
    lang: string,
  ): Promise<AppleAppInfoT[]> {
    const wa = getCurrWorkspaceAlias();
    const res = await defaultAxios.get<AppleAppInfoT[]>(
      `/workspaces/${wa}/apple_app_store/search?term=${term}&country=${country}&lang=${lang}`,
    );
    return res.data;
  },
  async disconnectApp(app_id: string): Promise<void> {
    await defaultAxios.delete(`/apple_app_store/${app_id}`);
  },
};

export default appleAppService;
